import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { installAnalytics } from "./analytics";
import type { RouteKind } from "./content/types";
import { getBrowserLandingRedirect, localizedPaths, locales } from "./i18n/routes";
import { pageByKind } from "./pages";
import { LandingPage } from "./pages/LandingPage";

function getBasename() {
  const base = import.meta.env.BASE_URL || "/";
  return base === "/" ? "/" : base.replace(/\/$/, "");
}

function BrowserLocaleLandingRoute() {
  const browserLandingRedirect = getBrowserLandingRedirect();
  if (browserLandingRedirect) return <Navigate to={browserLandingRedirect} replace />;

  return <LandingPage locale="en" />;
}

export function App() {
  useEffect(() => {
    installAnalytics();
  }, []);

  return (
    <BrowserRouter basename={getBasename()}>
      <Routes>
        <Route path="/" element={<BrowserLocaleLandingRoute />} />
        {(Object.keys(localizedPaths) as RouteKind[]).flatMap((kind) =>
          locales.map((locale) => {
            const path = localizedPaths[kind][locale];
            // "/" 单独处理：要先按浏览器语言决定是否跳转
            if (path === "/") return null;
            const Page = pageByKind[kind];
            return <Route key={path} path={path} element={<Page locale={locale} />} />;
          })
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
